export default __webpack_public_path__ + "static/media/Dubai-bc.69f75b21.jpg";